/**
 * <QuizScore> — le score d'un quiz de prérequis, en anneau (molecule).
 *
 * L'ancien `QuizScoreRing` de « Revoir le quiz » : l'anneau rempli à la part des bonnes réponses,
 * vert si le quiz est réussi, rouge sinon, « 3/5 » et « 60 % » au centre, puis « Quiz réussi » ou
 * « Quiz non réussi » dessous.
 *
 * Ce qui change : l'anneau ne se remplit pas en 0,9 s et le score ne défile pas — les nombres
 * arrivent écrits, comme sur l'écran de fin d'une activité.
 */
import React from "react"

import { CircularProgress } from "../../atoms/CircularProgress"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"

export type QuizScoreProps = {
    score: number
    total: number
    /** Arrondi. */
    percentage: number
    passed: boolean
    testID?: string
}

/** Le diamètre de l'anneau (118 aujourd'hui, réduit pour tenir dans la feuille) : son squelette le reprend. */
export const QUIZ_SCORE_RING_SIZE = 96

const TEXTS = {
    score: (score: number, total: number) => `${score}/${total}`,
    percentage: (value: number) => `${value} %`,
    passed: "Quiz réussi",
    failed: "Quiz non réussi",
}

export function QuizScore(props: QuizScoreProps) {
    const { score, total, percentage, passed, testID } = props

    return (
        <Stack gap="2" align="center" testID={testID}>
            <CircularProgress
                value={percentage}
                size={QUIZ_SCORE_RING_SIZE}
                strokeWidth={8}
                color={passed ? "success" : "danger"}
                trackColor={passed ? "successLight" : "dangerLight"}
                label={TEXTS.score(score, total)}
                sublabel={TEXTS.percentage(percentage)}
            />
            <Text size="text-base" weight="semibold" color={passed ? "success-strong" : "danger-strong"} center>
                {passed ? TEXTS.passed : TEXTS.failed}
            </Text>
        </Stack>
    )
}
